import React, { forwardRef } from 'react';
import { cn } from '@mentimeter/ragnar-tailwind-config';
import { Arrow, type PopoverArrowProps } from '@radix-ui/react-popover';

export const PopoverArrow = forwardRef<SVGSVGElement, PopoverArrowProps>(
  (props, ref) => {
    const { className, ...rest } = props;
    return (
      <Arrow
        ref={ref}
        className={cn('fill-(--color-surface)', className)}
        {...rest}
      />
    );
  },
);
